import { Box } from 'components/Box'
import { Icon } from 'components/Icon'
import { styled } from 'stitches.config'

export const CheckboxIcon = styled(Icon, {
  pointerEvents: 'none',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '$surface-100',
  opacity: 0,
})

export const CheckboxInput = styled('input', {
  appearance: 'none',
  border: '1px solid $tertiary-900',
  borderRadius: '$1',
  margin: 0,
  transition: 'border 0.2s ease-in',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '$tertiary-200',
  },
  '&:active': {
    backgroundColor: '$tertiary-400',
  },
  '&:checked': {
    [`& + ${CheckboxIcon}`]: {
      size: '100%',
      opacity: 1,
      color: '$accent-white',
    },
  },
  '&:disabled': {
    cursor: 'not-allowed',
    border: '1px solid $tertiary-400',
  },

  variants: {
    variant: {
      primary: {
        '&:checked': {
          backgroundColor: '$tertiary-900',
        },
      },
      secondary: {
        border: '1px solid $secondary-600',
        '&:checked': {
          border: '1px solid $secondary-800',
          backgroundColor: '$secondary-800 !important',
        },
      },
      primaryRed: {
        border: '1px solid $secondary-600',
        '&:checked': {
          border: '1px solid $accent-red',
          backgroundColor: '$accent-red !important',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
})

export const CheckboxContainer = styled(Box, {
  display: 'inline-block',
  position: 'relative',
  size: '$2',
  marginRight: '$1',

  '&': {
    [`${CheckboxInput}`]: {
      size: '100%',
    },
  },
})

export const CheckboxRoot = styled('div', {
  display: 'flex',
  alignItems: 'center',
  color: '$tertiary-900',
  lineHeight: '$headline',
  fontSize: '$headline',

  '& input': {
    marginBottom: '$1',
  },

  label: {
    width: 'fit-content',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  variants: {
    variant: {
      primary: {
        [`& ${CheckboxInput}`]: {
          '&:checked': {
            backgroundColor: '$tertiary-900',
          },
        },
      },
      secondary: {
        [`& ${CheckboxInput}`]: {
          border: '1px solid $secondary-600',
          '&:checked': {
            border: '1px solid $secondary-800',
            backgroundColor: '$secondary-800',
          },
        },
      },
      primaryRed: {
        [`& ${CheckboxInput}`]: {
          border: '1px solid $secondary-600',
          '&:checked': {
            border: '1px solid $accent-red',
            backgroundColor: '$accent-red',
          },
        },
      },
    },
    disabled: {
      true: {
        color: '$tertiary-400',
      },
    },
  },

  defaultVariants: {
    variant: 'primary',
  },
})

export const CheckboxLabelIcon = styled('div', {
  marginRight: '$1',
  variants: {
    size: {
      small: {
        size: '$4',
      },
      medium: {
        size: '$6',
      },
      large: {
        size: '$8',
      },
    },
  },
})
